if ($('#app-ratings-tv-program').length) {
    var table_data = [];

    var data_dists;
    var curr_dist;
    var curr_day;
    var curr_program;
    var curr_pop;

    var book;
    var distributors;
    var day_part;
    var req_demo;

    var form_curr_market;
    var form_curr_playback;
    var form_curr_dists;

    var dt;

    var playback_types = {
        'LPM': {
            'LO': 'Live Only',
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'SRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'CRM': {
            'LS': 'Live Plus Same Day',
            'L3': 'Live Plus 3',
            'L7': 'Live Plus 7'
        },
        'DIA': {
            'L1': 'Live Plus 1'
        }
    };

    var playback_types_all = {
        'LO': 'Live Only',
        'LS': 'Live Plus Same Day',
        'L3': 'Live Plus 3',
        'L7': 'Live Plus 7',
        'L1': 'Live Plus 1'
    };


    $(document).ready(function(){
        demos = collect(demos);

        $('.tv-select-demo-container input[type="radio"]').on('change', function () {
            var demo_type = $(this).val();
            var select = $($(this).closest('.tv-select-demo-container').find('select')[0]);
            select.html('');
            select.attr('disabled', null);

            if (demo_type === 'hh') {
                select.append('<option value="hh" selected>-</option>');
                $(this).closest('.tv-select-demo-container').find('.demo_name')
                    .val('hh');
                select.attr('readonly', 'readonly');
            } else if (demo_type === '') {
                select.append('<option value="" selected>-</option>');
                select.attr('disabled', 'disabled');
            } else if (demo_type === 'p') {
                demos.each(function (item) {
                    var ids = "";
                    var string = "";
                    $.each(item['blocks']['p'], function (index, value) {
                        ids += value.toString() + ',';
                    });
                    if (item['end'] === null) {
                        string = item['start'] + "+";
                    } else {
                        string = item['start'] + "-" + item['end'];
                    }

                    select.append('<option value="' + ids + '">' + string + '</option>');
                });
            } else {
                demos.each(function (item) {
                    if ((item['start'] !== 6) && (item['start'] !== 2)) {
                        var ids = "";
                        var string = "";
                        $.each(item['blocks'][demo_type], function (index, value) {
                            ids += value.toString() + ',';
                        });
                        if (item['end'] === null) {
                            string = item['start'] + "+";
                        } else {
                            string = item['start'] + "-" + item['end'];
                        }

                        select.append('<option value="' + ids + '">' + string + '</option>');
                    }
                });

                if (demo_type === 'f') {
                    select.append('<option value="ww">WW</option>');
                }
            }

            select.unbind('change').bind('change', function () {
                $(this).closest('.tv-select-demo-container').find('.demo_name')
                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
        });

        dayPartInputInit('16:00', '23:00', 'tv');
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/markets',
            dataType: 'json',
            success: function (data) {
                var input = $('#form_market');
                data = collect(data).sortBy('name').all();

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + index + '">' + value['name'] + '</option>')
                });

                form_markets = data;

                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).bind('change', function () {
                    ratingsProgramOnMarketChange(this);
                });

                $('#form_playback_type').select2({
                    placeholder: "Select a market...",
                    minimumResultsForSearch: 10
                });

                $('#form_book').select2({
                    placeholder: "Select a data stream...",
                    minimumResultsForSearch: 10
                });

                $('#form_dists').multiSelect(searchableMultiSelectDef);

                $('#form_reset').bind('click', function(){
                    ratingsProgramReset();
                });

                $('#form_submit').bind('click', function(){
                    ratingsProgramSubmit();
                });

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });

        show_loader();

    });

    var ratingsProgramSubmit = function(){
        book = $('#form_book').val();
        distributors = $('#form_dists').val();
        req_demo = $('#form_demo_ids').val();
        if(req_demo !== 'hh'){
            req_demo = req_demo.substring(0, (req_demo.length - 1));
            req_demo = req_demo.split(',');
        }else{
            req_demo = ['hh'];
        }


        dp_start = moment($('#form_day_part_start').val(), 'h:mm A');
        dp_end = moment($('#form_day_part_end').val(), 'h:mm A');

        day_part = $('#form_day_part_days').val() + dp_start.format('HHmm') + dp_end.format('HHmm');

        console.log("demoooo");
        console.log(req_demo);

        show_loader();
        $.ajax({
            url: '/ratings/tv/local/books/program?' + $.param({
                day_part: day_part,
                book: book,
                distributors: distributors,
                demos: req_demo
            }),
            success: function (data) {
                curr_pop = parseInt(data['population']);
                data_dists = data['distributors'];

                table_data = [];

                $.each(data['data'], function(index, value){
                    curr_dist = collect(data_dists).where('id', '==', index).first();
                    $.each(value, function(index, value){
                        if(parseInt(index) === 1){
                            curr_day = 'U';
                        }else if(parseInt(index) === 2){
                            curr_day = 'M';
                        }else if(parseInt(index) === 3){
                            curr_day = 'T';
                        }else if(parseInt(index) === 4){
                            curr_day = 'W';
                        }else if(parseInt(index) === 5){
                            curr_day = 'R';
                        }else if(parseInt(index) === 6){
                            curr_day = 'F';
                        }else if(parseInt(index) === 7){
                            curr_day = 'S';
                        }

                        $.each(value, function(index, value){
                            var start_time = moment(value['start'], 'HH:mm');
                            curr_program = index;
                            if(value['subtitle'] !== null){
                                curr_program = curr_program + ' (' + value['subtitle'] + ')';
                            }
                            table_data.push({
                                station: curr_dist['call_letters'],
                                day: curr_day,
                                start: start_time.format('h:mm A'),
                                program: curr_program,
                                tel: value['tel'],
                                impressions: parseFloat(value['impressions']),
                                rating: (parseFloat(value['impressions']) / curr_pop) * 100
                            });
                        });
                    });
                });

                table_data = collect(table_data).sortByDesc('rating').all();


                var x = 0;
                $.each(table_data, function(index, value){
                    x++;
                    table_data[index]['rank'] = x;
                });

                var dt_options = {
                    data: table_data,
                    columns: [
                        {
                            data: "rank",
                            title: "Rank"
                        },{
                            data: "station",
                            title: "Station"
                        },{
                            data: "day",
                            title: "Day",
                            width: '50px'
                        },{
                            data: "start",
                            title: "Start Time",
                            width: "100px"
                        },{
                            data: "program",
                            title: "Program"
                        },{
                            data: "tel",
                            title: "# Tel",
                            width: '50px'
                        },{
                            data: "impressions",
                            title: "000"
                        },{
                            data: "rating",
                            title: "Rtg",
                            type: 'num'
                        },
                    ],
                    columnDefs: [
                        {
                            orderable: false,
                            targets: '_all'
                        },
                        {
                            searchable: false,
                            targets: [ 2, 3, 4, 6, 7 ]
                        },
                        {
                            render: function ( data, type, row, meta ) {
                                return Math.floor(data / 1000).toLocaleString("en-US", {
                                    minimumFractionDigits: 0
                                });
                            },
                            targets: 6
                        },
                        {
                            render: function ( data, type, row, meta ) {
                                return data.toFixed(1);
                            },
                            targets: 7
                        },
                        {
                            "width": "7.5%",
                            "targets": [0, 2, 5, 6, 7]
                        },
                        {
                            "width": "12.5%",
                            "targets": [3]
                        },
                        {
                            "width": "25%",
                            "targets": [1, 4]
                        }
                    ],
                    pageLength: 25,
                    dom: 'Bfrtip',
                    buttons: [
                        'copy', 'csv', 'excel', 'print'
                    ],
                };

                if(typeof dt !== 'undefined'){
                    dt.destroy();
                    $('#ratings_program_table').empty();
                }

                dt = $('#ratings_program_table').DataTable( dt_options );

                var header = $('#tv_program_header');

                header.find('#book').html(data['book']['market']['name'] + ' ' + data['book']['month'] + '/' +
                    data['book']['year'] + '; ' + data['book']['playback_type']);
                header.find('#day_part').html(ratingsHumanDaypart(day_part));

                demo_cont = $('.tv-select-demo-container');
                demo_string = demo_cont.find('input[name="demo_type"]:checked').val().toUpperCase() +
                    demo_cont.find('input[name="form_demo_name"]').val();

                header.find('#demo').html(demo_string);

                if(data['intab'] === true){
                    $('#nielsen-disclaimer').find('span.intab-disclaimer').addClass('hidden');
                }else{
                    $('#nielsen-disclaimer').find('span.intab-disclaimer').removeClass('hidden');
                }

                if($('.ratings-table-container').hasClass('hidden')){
                    $('.ratings-table-container').removeClass('hidden');
                }

//                    ratingsProgramReset();
                $('#tv_program_generate_panel').find('div.clickable').click();


                hide_loader();
            }
        });
    };

    var ratingsProgramReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

            input.data('select2').destroy();

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + index + '">' + value['name'] + '</option>')
            });

            input.attr('disabled', null);
            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            });
            input.unbind('change').bind('change', function () {
                ratingsProgramOnMarketChange(this);
            });
        }

        if((step < 2) || (step === 'all')){
            input = $('#form_playback_type');

            input.data('select2').destroy();
            input.unbind('change');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a market...",
                minimumResultsForSearch: 10
            });
        }

        if((step < 3) || (step === 'all')) {
            input = $('#form_book');

            input.data('select2').destroy();
            input.unbind('change');
            input.html('');
            input.attr('disabled', 'disabled');
            input.select2({
                placeholder: "Select a data stream...",
                minimumResultsForSearch: 10
            });
        }

        if((step < 4) || (step === 'all')) {
            input = $('#form_dists');
            input.multiSelect('destroy');
            input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form_dists_container').addClass('hidden');
            input.closest('.form_dists_container').parent().find('.help-text').removeClass('hidden');
        }
    };

    var ratingsProgramOnMarketChange = function(select) {
        form_curr_market = form_markets[$(select).val()];
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'],
            dataType: 'json',
            success: function (data) {
                console.log("books");
                //console.log(data);
                console.log(collect(data).keyBy('playback_type').all());
                var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();

                var input = $('#form_playback_type');
                input.attr('disabled', null);
                input.data('select2').destroy();
                input.html('').append('<option value=""></option>');
                $.each(form_playbacks, function (index, value) {
                    input.append('<option value="' + index + '">' + playback_types_all[index] + '</option>')
                });
                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                });
                input.bind('change', function () {
                    ratingsProgramOnPlaybackChange(this);
                });
                ratingsProgramReset(2);
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
        /*
        form_playbacks = playback_types[form_curr_market['type']];

        var input = $('#form_playback_type');

        input.attr('disabled', null);
        input.data('select2').destroy();

        input.html('').append('<option value=""></option>');
        $.each(form_playbacks, function (index, value) {
            input.append('<option value="' + index + '">' + value + '</option>')
        });

        input.select2({
            placeholder: "Select...",
            minimumResultsForSearch: 10
        });

        input.bind('change', function () {
            ratingsProgramOnPlaybackChange(this);
        });

        ratingsProgramReset(2);
        */
    };


    var ratingsProgramOnPlaybackChange = function(select) {
        form_curr_playback = $(select).val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/allbooks/?dma=' + form_curr_market['dma'] + '&playback=' + form_curr_playback,
            dataType: 'json',
            success: function (data) {
                form_books = data;
                var input = $('#form_book');

                input.attr('disabled', null);
                input.data('select2').destroy();

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>')
                });

                input.select2({
                    placeholder: "Select...",
                    minimumResultsForSearch: 10
                });

                input.bind('change', function () {
                    ratingsMarketOnBookChange(this);
                });

                ratingsProgramReset(3);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    var ratingsMarketOnBookChange = function(select) {
        form_curr_book = $(select).val();

        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/tv/local/monthly/books/distributors/?books[]=' + form_curr_book,
            dataType: 'json',
            success: function (data) {
                form_dists = data;

                var input = $('#form_dists');

                input.multiSelect('destroy');
                input.html('');

                var html_broadcast = '';
                var html_cable = '';

                $.each(data, function (index, value) {
                    if (value['affil'] !== null) {
                        html_broadcast = html_broadcast + '<option value="' + value['id'] + '">'
                            + value['name'] + ' (' + value['affil'] + ')</option>';
                    } else {
                        html_cable = html_cable + '<option value="' + value['id'] + '">' + value['name'] + '</option>';
                    }
                });

                input.append('<optgroup label="Broadcast">' + html_broadcast + '</optgroup>');
                input.append('<optgroup label="Cable">' + html_cable + '</optgroup>');

                input.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_dists = this.$element.val();
                        if(this.$element.val().length <= 20){
                            $('#form_submit').removeAttr('disabled');
                        }else{
                            this.$element.multiSelect('deselect', values);
                            //form_curr_dists = this.$element.val();
                            //$('#form_submit').attr('disabled', 'disabled');

                            swal({
                                    title: "Warning",
                                    text: "The limit of Stations is 20...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if(form_curr_dists.length < 20){
                            this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_dists.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_dists.length + ' / 20)').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();

                        form_curr_dists = this.$element.val();
                        if(form_curr_dists.length > 0){
                            console.log('asd');
                            $('#form_submit').removeAttr('disabled');
                        }else{
                            $('#form_submit').attr('disabled', 'disabled');
                        }

                        this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_dists.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                input.closest('.form_dists_container').removeClass('hidden');
                input.closest('.form_dists_container').parent().find('.help-text').addClass('hidden');

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };
};